<template>
	<div class="cu2">
		<!-- Header -->
		<div
			class="flex xs-12 xs-middle xs-between pb3 pt3 pr2 pl2"
			:class="decideClass"
			@click="isExpanded = !isExpanded"
		>
			<p class="fs3 fw7" :class="{ c5: isExpanded, c6: !isExpanded }">
				<slot name="title"></slot>
			</p>
			<crm-icon v-if="!isExpanded" name="down" color="c6" />
			<crm-icon v-else name="up" color="c5" />
		</div>

		<!-- Body -->
		<div v-if="isExpanded" :class="bodyClass">
			<slot name="body"></slot>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon/"

export default {
	components: { JButton, CrmIcon },

	props: {
		// classes will be applied to body slot
		bodyClass: String,
		startOpen: {
			type: Boolean,
			default: () => false
		},
		colorWhenOpen: {
			type: String,
			default: () => "bg1"
		},
		colorWhenClosed: {
			type: String,
			default: () => "bg4"
		}
	},

	data() {
		return {
			isExpanded: this.startOpen
		}
	},

	computed: {
		decideClass() {
			return this.isExpanded ? this.colorWhenOpen : this.colorWhenClosed
		}
	}
}
</script>
